import styled from 'styled-components';

export const EmailEllipsis = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  word-wrap: normal;
`;
